import { render } from "./AddTagForm.vue?vue&type=template&id=35d8d1e4&scoped=true"
import script from "./AddTagForm.vue?vue&type=script&lang=js"
export * from "./AddTagForm.vue?vue&type=script&lang=js"

import "./AddTagForm.vue?vue&type=style&index=0&id=35d8d1e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d8d1e4"]])

export default __exports__